<template>
    <app-layout>
        <template #header>
            <AppHead title="Return & Warranty" />
            <h3 class="title mb-2">
                Returns
            </h3>
        </template>

        <div class="tab-content mt-4">
            <ReturnsUserDashboard :mtdId="mtdId" />
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import ReturnsUserDashboard from '@/Components/Returns/ReturnsUserDashboard.vue';

export default {
    components: {
        AppLayout,
        ReturnsUserDashboard,
    },
    props: {
        mtdId: Object,
    },
}
</script>
